// Test IDs for the hidden LIASROOTS campaign module (public pages + internal queue).
export const CAMPAIGN = {
  landing: 'liasroots-landing',
  heroCta: 'liasroots-hero-cta',
  stateBanner: 'liasroots-state-banner',
  form: 'liasroots-form',
  field: (n) => `liasroots-field-${n}`,
  service: (k) => `liasroots-service-${k}`,
  priority: (k) => `liasroots-priority-${k}`,
  channel: (k) => `liasroots-channel-${k}`,
  membership: (k) => `liasroots-membership-${k}`,
  sgops: (k) => `liasroots-sgops-${k}`,
  phone: 'liasroots-field-phone',
  marketing: 'liasroots-marketing',
  submit: 'liasroots-submit',
  errorSummary: 'liasroots-error-summary',
  confirm: 'liasroots-confirmation',
  reference: 'liasroots-reference',
  profileLink: 'liasroots-profile-link',
  profile: 'liasroots-profile',
  profileSave: 'liasroots-profile-save',
  profileSkip: 'liasroots-profile-skip',
  fieldUen: 'liasroots-profile-uen',
  unsubscribe: 'liasroots-unsubscribe',
};

export const LEADQ = {
  root: 'leadq-root',
  stat: (k) => `leadq-stat-${k}`,
  capacity: 'leadq-capacity',
  filter: (k) => `leadq-filter-${k}`,
  row: (id) => `leadq-row-${id}`,
  detail: 'leadq-detail',
  statusSelect: 'leadq-status-select',
  statusReason: 'leadq-status-reason',
  statusApply: 'leadq-status-apply',
  releaseBtn: 'leadq-release',
  ownerInput: 'leadq-owner-input',
  ownerSave: 'leadq-owner-save',
  stateSelect: 'leadq-state-select',
  exportBtn: 'leadq-export',
  analytics: 'leadq-analytics',
  uenInput: 'leadq-uen-input',
  uenSave: 'leadq-uen-save',
  related: 'leadq-related',
};
